export default __webpack_public_path__ + "static/media/slide11.b221075b.jpg";